import accountDao from '../../../../dao/accountDao';
import {loadAuth} from '../../../../components/auth/reducers';

const RESET = 'pages/generalsettings/accountsettings/personalprofile/RESET';
const QUERY_ACCOUNT =
  'pages/generalsettings/accountsettings/personalprofile/QUERY_ACCOUNT';
const QUERY_ACCOUNT_SUCCESS =
  'pages/generalsettings/accountsettings/personalprofile/QUERY_ACCOUNT_SUCCESS';
const UPDATE_ACCOUNT =
  'pages/generalsettings/accountsettings/personalprofile/UPDATE_ACCOUNT';
const UPDATE_ACCOUNT_SUCCESS =
  'pages/generalsettings/accountsettings/personalprofile/UPDATE_ACCOUNT_SUCCESS';
const UPDATE_ACCOUNT_FAIL =
  'pages/generalsettings/accountsettings/personalprofile/UPDATE_ACCOUNT_FAIL';
const SHOW_PASSWORD_FIELDS =
  'pages/generalsettings/accountsettings/personalprofile/SHOW_PASSWORD_FIELDS';

const initialState = {
  isLoaded: false,
  isShowPWFields: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET:
      return {...initialState};
    case QUERY_ACCOUNT:
      return {
        ...state,
        isLoaded: false,
      };
    case QUERY_ACCOUNT_SUCCESS:
      return {
        ...state,
        isLoaded: true,
      };
    case UPDATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        isShowPWFields: false,
      };
    case SHOW_PASSWORD_FIELDS:
      return {
        ...state,
        isShowPWFields: true,
      };
    default:
      return state;
  }
};

export function reset() {
  return {type: RESET};
}

export function queryAccount() {
  return dispatch => {
    dispatch({type: QUERY_ACCOUNT});

    return accountDao.queryAccount().then(json => {
      dispatch({type: QUERY_ACCOUNT_SUCCESS});
      return json;
    });
  };
}

export function updateAccount(account) {
  return dispatch => {
    dispatch({type: UPDATE_ACCOUNT});

    return accountDao
      .updateAccount(account)
      .then(json => dispatch(updateAccountSuccess(json)))
      .catch(error => dispatch(updateAccountFail(error)));
  };
}

function updateAccountSuccess(account) {
  return dispatch => {
    dispatch({type: UPDATE_ACCOUNT_SUCCESS});
    dispatch(loadAuth());
    return account;
  };
}

function updateAccountFail(error) {
  return dispatch => {
    dispatch({type: UPDATE_ACCOUNT_FAIL});
    return Promise.reject(error);
  };
}

export function showPasswordFields() {
  return {type: SHOW_PASSWORD_FIELDS};
}
